export const DashboardDeadlineIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6.375 3C6.58125 3 6.75 3.16875 6.75 3.375V4.5H11.25V3.375C11.25 3.16875 11.4187 3 11.625 3C11.8313 3 12 3.16875 12 3.375V4.5H12.75C13.5773 4.5 14.25 5.17266 14.25 6V6.75V7.5V13.5C14.25 14.3273 13.5773 15 12.75 15H5.25C4.42266 15 3.75 14.3273 3.75 13.5V7.5V6.75V6C3.75 5.17266 4.42266 4.5 5.25 4.5H6V3.375C6 3.16875 6.16875 3 6.375 3ZM13.5 7.5H4.5V13.5C4.5 13.9148 4.83516 14.25 5.25 14.25H12.75C13.1648 14.25 13.5 13.9148 13.5 13.5V7.5ZM12.75 5.25H5.25C4.83516 5.25 4.5 5.58516 4.5 6V6.75H13.5V6C13.5 5.58516 13.1648 5.25 12.75 5.25Z"
            fill="#5C5E61"
        />
    </svg>
);
